import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { useSelector } from 'react-redux';
import React, { useState, useCallback } from 'react';
import { Skeleton, Space } from 'antd';
import { HeadingV2Preview } from '@module/form-components';
import { styled } from '@xstyled/styled-components';
import { QuestionManager } from '@module/form-components';
import { useQuestionPreviewHook } from '../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ContentWrapper = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
export var QuestionPreviewItem = function QuestionPreviewItem(_ref) {
  var key = _ref.key,
      question = _ref.question,
      index = _ref.index,
      labels = _ref.labels,
      onPin = _ref.onPin,
      pinnedQuestionId = _ref.pinnedQuestionId,
      onCancelPin = _ref.onCancelPin,
      selectedQuestionId = _ref.selectedQuestionId,
      onSelectQuestion = _ref.onSelectQuestion,
      audioPlayerLabels = _ref.audioPlayerLabels,
      speakingLabel = _ref.speakingLabel,
      questionDescriptionLabel = _ref.questionDescriptionLabel;
  var propRegistry = useQuestionPreviewHook({
    question: question,
    isSelected: selectedQuestionId === question.id.toString(),
    onPin: onPin,
    onCancelPin: onCancelPin,
    pinnedQuestionId: pinnedQuestionId,
    onSelectQuestion: onSelectQuestion,
    hideExplanation: true,
    // Hide explanation in form-preview
    customLabels: {
      question: labels.questionNumber,
      score: labels.score
    },
    audioPlayerLabels: audioPlayerLabels,
    speakingLabel: speakingLabel,
    questionDescriptionLabel: questionDescriptionLabel
  });
  return /*#__PURE__*/_jsx(QuestionManager, {
    question: question,
    mode: "preview",
    propsRegistry: propRegistry,
    index: index
  }, key);
};
export var QuestionsPreviewContainer = function QuestionsPreviewContainer(_ref2) {
  var _page$isLoadingQuesti;

  var questionsWithHeadings = _ref2.questionsWithHeadings,
      onPin = _ref2.onPin,
      pinnedQuestionId = _ref2.pinnedQuestionId,
      onCancelPin = _ref2.onCancelPin,
      labels = _ref2.labels,
      audioPlayerLabels = _ref2.audioPlayerLabels,
      speakingLabel = _ref2.speakingLabel,
      questionDescriptionLabel = _ref2.questionDescriptionLabel;
  // Selectors
  var page = useSelector(function (state) {
    return state.formPreviewApp;
  });
  var isLoadingQuestions = (_page$isLoadingQuesti = page === null || page === void 0 ? void 0 : page.isLoadingQuestions) !== null && _page$isLoadingQuesti !== void 0 ? _page$isLoadingQuesti : false; // Manage selected question state

  var _useState = useState(null),
      selectedQuestionId = _useState[0],
      setSelectedQuestionId = _useState[1];

  var handleSelectQuestion = useCallback(function (questionId) {
    setSelectedQuestionId(questionId);
  }, []); // UI

  var renderQuestions = function renderQuestions() {
    if (!questionsWithHeadings || isLoadingQuestions === true) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(Skeleton, {
          active: true,
          paragraph: {
            rows: 10
          }
        })
      });
    }

    return /*#__PURE__*/_jsx(ContentWrapper, {
      size: "middle",
      direction: "vertical",
      children: questionsWithHeadings.map(function (item, index) {
        if (item.type === 'heading') {
          var heading = item;
          return /*#__PURE__*/_jsx("div", {
            id: item.id.toString(),
            children: /*#__PURE__*/_jsx(HeadingV2Preview, {
              heading: heading,
              readonly: true
            })
          }, item.id.toString());
        } else {
          var question = item;
          return /*#__PURE__*/_jsx(QuestionPreviewItem, {
            question: question,
            index: index,
            labels: labels,
            onPin: onPin,
            pinnedQuestionId: pinnedQuestionId,
            onCancelPin: onCancelPin,
            selectedQuestionId: selectedQuestionId,
            onSelectQuestion: handleSelectQuestion,
            audioPlayerLabels: audioPlayerLabels,
            speakingLabel: speakingLabel,
            questionDescriptionLabel: questionDescriptionLabel
          }, question.id.toString());
        }
      })
    });
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderQuestions()
  });
};